<template>
  <v-container fluid fill-height pa-0 >
    <v-toolbar
      :class="background != 'transparent' ? background : ''"
      :style="background == 'transparent' ? 'background-color: ' + background : ''"
      flat
      dense
      height="40px"
    >
      <v-breadcrumbs
        style="padding: 0px 0px"
      >
          <v-breadcrumbs-item
            v-for="(item, index) in getCrumbs"
            :key="index"
            :class="'font-weight-regular'"
            @click="() => clickHandler(item)"
          > 
            <span v-if="!coloredText" :class="text + '--text ' + size" style="cursor: default">{{ item.name }}</span>
            <span v-if="coloredText" :style="`cursor: default; margin-left: 6px; color: ${$getColor($store.state.monitoring.status[item.$id])}`">{{ item.name }}</span>
          </v-breadcrumbs-item>

          <template v-slot:divider>
            <v-flex pt-1 px-1>
              <v-icon :size="24" :color="text">chevron_right</v-icon>
            </v-flex>
          </template>
      </v-breadcrumbs>
      <v-spacer></v-spacer>
      <v-btn :data-testid="$options.name + 'v-btn' + 'emit-action'" color="primary" @click="$emit('action')" v-if="$attrs['with-button']!=undefined">{{$attrs['btn-caption']}}</v-btn>
    </v-toolbar>
  </v-container>
</template>

<script lang="ts">
  import Vue from 'vue'

  interface BreadcrumbItem {
    $id: string
    name: string
    [key: string]: any
  }

  export default Vue.extend({
    
    name: 'CRUMBS',

    props: {
      crumbs: {
        type: Array as () => BreadcrumbItem[],
        default: () => []
      },
      size: {
        type: String,
        default: () => 'subheading'
      },
      clickable: {
        type: Boolean,
        default: () => true
      },
      withStatus: {
        type: Boolean,
        default: () => true
      },
      background: {
        type: String,
        default: () => 'primary'
      },
      text: {
        type: String,
        default: () => 'white'
      },
      coloredText: {
        type: Boolean,
        default: () => false
      },
    },

    data() {
      return {
        loader: false
      }
    },

    computed: {
      getCrumbs(): BreadcrumbItem[] {
        return this.crumbs
      }
    },

    created(): void {
      if (this.coloredText) {
        this.statusUnsubscribe('crumbs')
        this.statusSubscribe(this.crumbs, 'crumbs')
      }
    },

    beforeDestroy(): void {
      if (this.coloredText) {
        this.statusUnsubscribe('crumbs')
      }
    },

    methods: {
      clickHandler(item: BreadcrumbItem): void {
        if (this.clickable) {
          this.loadData(item.$id)
        }
      },

      async loadData(id: string): Promise<void> {
        try {
          const query = {
            id: [id],
            notNull: true,
            data: {
              links: {
                flatten: false,
              }
            }
          }
          const parent = await this.$bridge.cmdbQuery(query)
          const obj = this.$merge({}, parent[0])
          obj.children = obj.links
          this.$store.dispatch('selectLocation', obj)
        } catch (err) {
          console.error('CATCH', this.$options.name, 'loadData', err)
          this.loader = false
        }
      },

      async statusSubscribe(arr: BreadcrumbItem[], group: string): Promise<void> {
        this.$store.dispatch('measuresSubscribeInit', {
          name: 'addStatus',
          group: group,
          listener: 'status'
        })
        if (arr.length) {
          await this.$bridge.subscribe(arr.map(obj => obj.$id))
        }
      },

      subscribeHandler(e: any): void {
        if (e.$id) {
          this.$store.dispatch('addStatus', e)
        }
      },

      statusUnsubscribe(group: string): void {
        this.$store.dispatch('measuresSubscribeClose', {
          handler: this.subscribeHandler,
          group: group,
          listener: 'status'
        })
      }
    }
  })
</script>

<style scoped>

.v-breadcrumbs li:nth-child(even) {
  padding: 0px !important
}

.v-breadcrumbs li:nth-child(2n) {
  padding: 0px !important
}

</style>
